"use client";

import { useTranslations } from "next-intl";
import NavigationLink from "@/common/navigation-link.common";
import { Button, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";

export const WelcomeSection = () => {
  const t = useTranslations();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Container 
      sx={{
        padding: {
          xs: "8rem 1rem 2rem 1rem", 
          sm: "9rem 1.5rem 2.5rem 1.5rem", 
          md: "10rem 2rem 3rem 2rem", 
        },
        minHeight: {
          xs: "70vh", 
          md: "60vh",
        },
        backgroundSize: "cover",
        backgroundPosition: {
          xs: "center center", 
          md: "center 65%", 
        },
        backgroundImage: 'url("/landing-page.jpeg"), linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
        backgroundBlendMode: "multiply",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }} 
      variant="dull" 
      maxWidth={false}
    >
      <Typography 
        align="center" 
        sx={{
          fontSize: {
            xs: "1.5rem", 
            sm: "1.75rem",
            md: "2rem",
          },
          lineHeight: {
            xs: 1.3,
            md: 1.5,
          },
          marginBottom: {
            xs: 4,
            sm: 6,
            md: 8,
          }
        }} 
        color="#fff" 
        variant="h1"
      >
        {t("Nagpur District Administrator")}
        <br />
        {t("Portal for application under Regulated Activities in ESZ")}
      </Typography>

      <Box 
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          gap: {
            xs: 2,
            sm: 4, 
            md: 8, 
          },
          mt: {
            xs: 4, 
            sm: 8,
            md: 12, 
          },
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <NavigationLink href="/login">
          <Button 
            sx={{
              paddingLeft: {
                xs: "2rem", 
                sm: "4rem",
                md: "6rem", 
              },
              paddingRight: {
                xs: "2rem",
                sm: "4rem",
                md: "6rem",
              },
              width: {
                xs: "100%",
                sm: "auto",
              },
            }} 
            variant="outlined" 
            color="inverted"
          >
            {t("Login Now")}
          </Button>
        </NavigationLink>
        
        <NavigationLink href="/register">
          <Button 
            sx={{
              paddingLeft: {
                xs: "2rem",
                sm: "4rem",
                md: "6rem",
              },
              paddingRight: {
                xs: "2rem",
                sm: "4rem",
                md: "6rem",
              },
              width: {
                xs: "100%",
                sm: "auto",
              },
            }} 
            variant="contained"
          >
            {t("Register Now")}
          </Button>
        </NavigationLink>
      </Box>
    </Container>
  );
};

export default WelcomeSection;